export default __webpack_public_path__ + "static/media/DesignFactory.b93bbeb3.gif";